import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class ActivityTypeRefResponseDto {
  @ApiProperty({ type: 'string' })
  id!: string;

  @ApiProperty({ type: 'string' })
  code!: string;

  @ApiProperty({ type: 'string' })
  label!: string;

  @ApiPropertyOptional({ type: Object })
  jsonSchema?: unknown;

  @ApiPropertyOptional({ type: Object })
  defaultConfig?: unknown;

  @ApiPropertyOptional({ type: 'string' })
  icon?: string;

  @ApiPropertyOptional({ type: 'string' })
  color?: string;
}
